import React, { useMemo } from "react";
import {
  Box,
  Card,
  Container,
  Stack,
  Typography,
  Checkbox,
} from "@mui/material";
import { useState, useEffect } from "react";
import Link from "@mui/material/Link";
import axios from "axios";
import { API } from "../../pages/backend";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from "sweetalert2";
import Spinner from "../../Component/ui/Spinner";
import { useDispatch } from "react-redux";
import { loggedInUser, setUser } from "../../store/reducers/user";
import FormButton from "../../Component/ui/button/FormButton";
import InputField from "../../Component/forms/input/TextInput/InputField";
import { apiRequest, baseURL } from "../../services/auth";
import { setTransactionDetails } from "../../store/reducers/transactionDetails";

const Login = ({ examType = "BECE EXAMINATION ", url, navigateTo, homeLink }) => {
  const navigate = useNavigate();
  // const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  // const [emailPhone, setEmailPhone] = useState("");

  const dispatch = useDispatch();
  // const handleRememberMeChange = () => {
  //     setRememberMe(!rememberMe);
  // };
  const formSchema = yup.object().shape({
    password: yup
      .string()
      .required("Password is required"),
      // .matches(
      //   /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
      //   "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
      // ),
  });

  //useForm
  const {
    setValue,
    handleSubmit,
    formState: { errors },
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const Login = async (value) => {
    // Check for client-side validation errors
    const isValid = await trigger(); // Trigger validation
    // Do not proceed if there are validation errors
    if (!isValid) return;
    setLoading(true);
    try {
      // const res = await apiRequest({
      //   method: "post",
      //   url: url,
      //   payload: value,
      //   successMessage: "",
      //   showError: false,
      // });
      const response = await fetch (`${baseURL}${url}`, {
        body: JSON.stringify(value),
        method: "POST",
        headers: {"content-Type": "application/json",},
      })
      const result = await response.json();
      const res = {
        data: result,
        hasError: !response.ok,
        status: response.status,
        statusText: response.statusText,
      };
      if (res?.data?.status === "success") {
        navigate(navigateTo);
        Swal.fire({
          title: "Successfully logged in",
          text: " You need to verify your payerID before you proceed.",
          icon: "success",
          confirmButtonText: "Ok",
        });
        dispatch(setTransactionDetails({ }))
        dispatch(setUser({ }))
        dispatch(loggedInUser(res?.data?.data));
        window.localStorage("token", JSON.stringify(res?.res?.data))
      } else if (res?.data?.status === "failed") {
        Swal.fire({
          title: "Error",
          text: res?.data?.message,
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    } catch (error) {
      if (error.response) {
      }
      
    } finally {
      setLoading(false);
    }
  };
  const location = useLocation();
  const [registerPage, setRegisterPage] = useState(null);

  const isDisabled = useMemo(() => {
    const { emailPhone, password } = watch();
    let bool = emailPhone && password;
    return !bool;
  }, [watch()]);

  useEffect(() => {
    if (location.pathname === "/public/payment/login") {
      setRegisterPage("/public/payment/register");
    } else if (location.pathname === "/tradetest/payment/login") {
      setRegisterPage("/trade/test/payment/register");
    } else if (location.pathname === "/model/payment/login") {
      setRegisterPage("/model/payment/register");
    } else if (location.pathname === "/bece/payment/login") {
      setRegisterPage("/bece/payment/register");
    } else if (location.pathname === "/cas/payment/login") {
      setRegisterPage("/cas/payment/register");
    } else if (location.pathname === "/tedac/payment/login") {
      setRegisterPage("/tedac/payment/register");
    } 
  }, [location.pathname]);

  return (
    <div>
      {/* <Container style={{width: '500px'}} > */}
      <Card
        className="login-card"
        elevation={5}
        style={{
          boxShadow: "2px 2px 5px 0px rgba(0, 0, 0, 0.5)",
        }}
      >
        <Container component="div">
          <Stack style={{ textAlign: "center", }}>
            <Typography variant="h5" style={{ fontWeight: "bold" }}>
              PORTAL LOGIN
            </Typography>
            <Typography variant="subtitle5" style={{ padding: "12px" }}>
              {" "}
              {examType}{" "}
            </Typography>
          </Stack>
          <div
            style={{
              // marginTop: "3rem",
              marginRight: window.innerWidth >= 601 ? "1.5rem" : "0.5rem",
              marginLeft: window.innerWidth >= 601 ? "1.5rem" : "0.5rem",
            }}
          >
            <form
              // style={{ marginLeft: "1.5rem" }}
              onSubmit={handleSubmit(Login)}
            >
              <Stack>
                <InputField
                  name="email or phone"
                  label="Email/Phone number"
                  type="emaail"
                  placeholder="Enter email or phone number"
                  onChange={(e) => {
                    setValue("emailPhone", e.target.value.trim());
                    // setPassword(e.target.value);
                  }}
                  style={{ height: "100%" }}
                />
              </Stack>

              <Stack>
                {/* <Stack style={{ display: 'flex' }}> */}
                <InputField
                  name="password"
                  label="Password"
                  type="password"
                  placeholder="Enter password"
                  // value={password}
                  password
                  onChange={(e) => {
                    setValue("password", e.target.value.trim());
                    // setPassword(e.target.value);
                  }}
                  style={{ height: "100%" }}
                // {...register("password")}
                />
                <Typography
                  sx={{
                    color: "#e53e3e",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                  style={{
                    visibility: errors.password ? "visible" : "hidden",
                  }}
                >
                  {errors.password?.message}
                </Typography>
                {/* </Stack> */}
              </Stack>
              {/* <div style={{ marginTop: '10px' }}>
                                    <Checkbox
                                        id='check'
                                        checked={rememberMe}
                                        onChange={handleRememberMeChange}
                                        color='secondary'
                                    />
                                    <Typography variant='p'>Remember Me</Typography>
                                </div> */}
              <Stack style={{ marginTop: "10px" }}>
                {/* Login Button */}
                <FormButton
                  type="submit"
                  label={loading ? <Spinner width="5%" /> : "Login"}
                  width="full"
                  // onClick={beceLogin}
                  disabled={isDisabled}
                />
              </Stack>


              <div>
                <Typography
                  variant="body2"
                  fontWeight="normal"
                  marginTop="0px"
                  textAlign="center"
                  cursor="pointer"
                >
                  <Link
                    href={registerPage}
                    style={{
                      textDecoration: "none",
                      color: "#34A56F",
                      fontWeight: "bold"
                    }}
                  >
                    Register{" "}
                  </Link>
                  {"  "}|
                  <Link
                 href={`/forgotPassword?examType=${encodeURIComponent(examType)}`}
                    style={{
                      textDecoration: "none",
                      color: "#34A56F",
                      fontWeight: "bold"
                    }}
                  >
                    {"  "}
                    Forgot password?
                  </Link>
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight="normal"
                  marginTop="10px"
                  textAlign="center"
                  cursor="pointer"
                  color="secondary"
                // marginBottom="2rem"
                >
                  <Link
                    href={homeLink}
                    target="_blank" rel="noopener noreferrer"
                    style={{
                      textDecoration: "none",
                      color: "#34A56F",
                      fontWeight: "normal"
                    }}
                  >
                    {"  "}
                    Back to home page
                  </Link>
                </Typography>
              </div>
            </form>
          </div>
          {/* <Footer /> */}
        </Container>
      </Card>
      {/* </Container> */}
    </div>
  );
};

export default Login;
